import React, {Component, Fragment} from 'react';
import ReferrerDomain from "../../components/statistics/referrer/ReferrerDomain";
import ReferrerLogs from "../../components/statistics/referrer/ReferrerLogs";
import If from "../../components/common/control/If";
import {checkAndGetMaintenanceMsg} from "../../components/statistics/common/CommonHelper";
import Maintenance from "../../components/statistics/common/Maintenance";

class StatisticsReferrerApp extends Component {

  constructor(props) {
    super(props);
    this.state = {lastUpdateTime: null};
    this.maintenanceMsg = checkAndGetMaintenanceMsg();
  }

  // 마지막 갱신시간
  handleSetLastUpdateTime = (lastUpdateTime) => {
    this.setState({
      lastUpdateTime: lastUpdateTime
    })
  };


  // Main 렌더링
  render() {
    const {lastUpdateTime} = this.state;
    const isMaintenance = this.maintenanceMsg !== null;

    return (
      <Fragment>
        <div className="blog_statistic">
          <h3 className="tit_cont">유입 경로<span className="desc_tit">최근 3일</span></h3>
          <If condition={isMaintenance}><Maintenance className="box_blog box_inspect" msg={this.maintenanceMsg}/></If>{/*점검페이지*/}
          <If condition={!isMaintenance}>
            <If condition={lastUpdateTime != null}><span className="info_rate_date">{lastUpdateTime} 기준</span></If>
            <div className="wrap_box">
              <ReferrerDomain handleSetLastUpdateTime={this.handleSetLastUpdateTime}/>
              <ReferrerLogs/>
            </div>
          </If>
        </div>
      </Fragment>
    );
  }
}

export default StatisticsReferrerApp;

